import { LAYOUT } from 'vars/index'
import {
  SkeletonUnitDirection,
  SkeletonUnitMargins,
} from '../../SkeletonUnit.h'

export const breakpointsWidthDateTabs = {
  1: '100%',
  767: '772px',
}
export const breakpointsMarginChannelLogo = {
  1: SkeletonUnitMargins.SIZE_90,
  1239: SkeletonUnitMargins.SIZE_40,
}
export const breakpointsWidthProgramCard = {
  1: '84px',
  1239: '165px',
}
export const breakpointsWidthPlayer = {
  1: `calc(100vw - 2 * var(${LAYOUT.HorizontalPaddings}))`,
  767: '432px',
  1919: '554px',
}
export const breakpointsMarginPlayer = {
  1: SkeletonUnitMargins.SIZE_70,
  767: SkeletonUnitMargins.SIZE_40,
}
export const breakpointsHeightDescription = {
  1: '68px',
  767: '162px',
  1919: '230px',
}
export const breakpointsMarginDescription = {
  1: SkeletonUnitMargins.SIZE_80,
  767: SkeletonUnitMargins.SIZE_20,
}
export const breakpointsDirectionInfoBlock = {
  1: SkeletonUnitDirection.Column,
  767: SkeletonUnitDirection.Row,
}
